import React from 'react';

import Section from './Section';

function Home() {
  // const navigate = useNavigate();
  // const handleNavigate = () => {
  //   navigate('/about')
  // }

  return (
    <div>
    <Section/>
  </div>


  );
}

export default Home;
